import lodashCompact from 'lodash/fp/compact';
import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_DRIVERS_GET_LIST } from 'api/actionTypes';

export default async function getDrivers({ state, apiClient }, { marketId, status } = {}) {
  typeCheck('marketId::Maybe PositiveNumber', marketId);
  typeCheck('status::Maybe NonEmptyString', status);

  const statePath = lodashCompact(['drivers', 'byMarketId', marketId]);
  if (marketId && state.get(statePath)) {
    return state.get(statePath);
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_DRIVERS_GET_LIST,
    state: state,
    payload: {
      marketId,
      status,
    },
    onSuccess(drivers) {
      if (marketId) {
        state.set(statePath, drivers);
      } else {
        state.set(
          statePath,
          drivers.reduce(
            (memo, driver) => ({
              ...memo,
              [driver.marketId]: [...(memo[driver.marketId] || []), driver],
            }),
            {},
          ),
        );
      }
      return drivers;
    },
  });
}
